import { getHeaders, makeRequest } from "$utils/utils";
import config from "$services/config";

const { shipping_api_url: shipping_url } = config;

export const createShippingFile = async (
  token: string,
  id: string,
  body: any
) => {
  try {
    const res = await makeRequest(
      `${shipping_url}/shippingRecords/${id}/file`,
      "POST",
      body,
      getHeaders(token)
    );
    return res.data;
  } catch (error: any) {
    return { error };
  }
};

export const deleteShippingFile = async (
  token: string,
  id: string,
  fileId: string
) => {
  try {
    const res = await makeRequest(
      `${shipping_url}/shippingRecords/${id}/file/${fileId}`,
      "DELETE",
      undefined,
      getHeaders(token)
    );
    return res.data;
  } catch (error: any) {
    return { error };
  }
};
